/*
 * Faster add to cart.
 *
 * Replaces $360.addToCart from vendor.min.js (minified, no source in this
 * repo) with the same behaviour, except for two things:
 *
 * 1. When the add ends in the header cart drawer, the drawer opens on click
 *    with its spinner and fills in once the cart has re-rendered. Before, it
 *    stayed shut until every request below had finished (1.3-1.8s).
 * 2. The Klaviyo "Added to Cart" event no longer holds the cart back: its
 *    product lookup runs after the cart is shown. The lookup also goes through
 *    the market root, so events from /en-au/ carry the AU product URL.
 *
 * Cart page and flash cart (PDP) adds keep their own UI and only gain (2).
 * $360.addToCartMultiple (personalised and accessory adds) is untouched.
 */
(function () {
  // $360 is a top-level const in vendor.min.js, so it is not on window
  if (typeof $360 === 'undefined' || typeof $360.addToCart !== 'function') return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  // If the drawer re-render never lands, do not leave a spinner behind
  var PLACEHOLDER_TIMEOUT = 15000;

  function drawer() {
    return document.getElementById('header-cart');
  }

  function flashCartOn() {
    return typeof flashCart !== 'undefined' && flashCart && flashCart.enableModule;
  }

  // Same branch order as vendor's addToCart: cart page, flash cart, drawer
  function endsInDrawer() {
    return !document.getElementById('cart-content') && !flashCartOn();
  }

  function openDrawerLoading() {
    var d = drawer();
    var overlay = document.querySelector('.header-cart-overlay');
    if (!d || !overlay) return false;

    var loader = d.querySelector('.header-cart-loading');
    if (loader) {
      // Previously rendered cart: keep it on screen under the spinner
      loader.classList.add('active');
    } else {
      // First add on this page, nothing rendered yet: show just the spinner.
      // showHeaderCart() replaces it with the real markup.
      d.innerHTML = '<div class="header-cart-loading cart-loading absolute top-0 left-0 w-full h-full zi-3 active" data-atc-placeholder>&nbsp;</div>';
    }

    // As showHeaderCart() does before it opens the drawer
    var mobileAtc = document.querySelector('.product-each-add-to-cart-mobile.active');
    if (mobileAtc) mobileAtc.classList.remove('active');

    d.classList.add('active');
    overlay.classList.add('active');
    document.body.classList.add('nooverflow');
    return true;
  }

  // Drop the spinner-only markup, so a later click on the cart icon renders
  // the cart instead of reopening an empty drawer
  function clearPlaceholder() {
    var d = drawer();
    if (d && d.querySelector('[data-atc-placeholder]')) d.innerHTML = '';
  }

  function closeDrawerLoading() {
    $360.hideHeaderCart();
    clearPlaceholder();
    var loader = document.querySelector('#header-cart .header-cart-loading');
    if (loader) loader.classList.remove('active');
  }

  function showCart(self) {
    if (document.getElementById('cart-content')) {
      self.refreshCartPage();
    } else if (flashCartOn()) {
      flashCart.handleShowPopup();
      axios.get(root + 'cart.js')
        .then(function (res) { self.updateHeaderCartCount(res.data); })
        .catch(function (err) { console.log(err); });
    } else {
      self.showHeaderCart({ update: true });
      setTimeout(function () {
        if (!drawer() || !drawer().querySelector('[data-atc-placeholder]')) return;
        closeDrawerLoading();
      }, PLACEHOLDER_TIMEOUT);
    }
  }

  function trackAddedToCart(item) {
    if (!window._learnq) return;
    axios.get(root + 'products/' + item.handle + '?variant=' + item.variant_id + '&view=klaviyo')
      .then(function (res) {
        var holder = document.createElement('div');
        holder.innerHTML = res.data;
        var data = holder.querySelector('#klaviyoData');
        if (!data) return;
        _learnq.push(['track', 'Added to Cart', {
          Brand: data.getAttribute('data-brand'),
          Categories: data.getAttribute('data-categories').split(','),
          CompareAtPrice: data.getAttribute('data-compare-at-price'),
          ImageURL: window.location.origin + '/cdn/shop/' + data.getAttribute('data-image-url'),
          Name: data.getAttribute('data-name'),
          Price: data.getAttribute('data-price'),
          ProductID: parseInt(data.getAttribute('data-product-id'), 10),
          URL: window.location.origin + data.getAttribute('data-url'),
          Value: data.getAttribute('data-value')
        }]);
      })
      .catch(function (err) { console.log(err); });
  }

  $360.addToCart = function (opts, callback, event) {
    var self = this;
    var button = opts.button;

    if (event && event.target && event.target.classList.contains('btn-add-cross-sell')) {
      var crossSellLoader = document.querySelector('.header-cart-loading');
      if (crossSellLoader) crossSellLoader.classList.add('active');
    }

    var label;
    if (button) {
      label = button.innerHTML;
      button.style.height = button.offsetHeight + 'px';
      button.style.width = button.offsetWidth + 'px';
      button.innerHTML = '&nbsp;<span class="btn-loading"></span>';
      button.setAttribute('disabled', true);
    }

    var openedEarly = endsInDrawer() && openDrawerLoading();

    var body = { quantity: opts.qty, id: opts.variantId };
    if (opts.properties) body.properties = opts.properties;

    var failed = false;
    var added = null;

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json(); })
      .then(function (item) {
        if (item.status) {
          // Shopify refused the add (sold out, quantity limit...)
          failed = true;
          if (openedEarly) closeDrawerLoading();
          alert(item.description);
          return;
        }
        added = item;
        if (typeof flashCart !== 'undefined' && flashCart) flashCart.itemKeysToShow = [item.key];
      })
      .catch(function (err) { console.log(err); })
      .finally(function () {
        if (!failed) {
          showCart(self);
          if (callback) callback();
        }
        if (button) {
          button.innerHTML = label;
          button.removeAttribute('disabled');
          button.style.height = '';
          button.style.width = '';
        }
        if (added) trackAddedToCart(added);
      });
  };
})();
